<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <hr class="space space-sm">
          <h1 class="h1-xl text-center">What we <span class="text-primary">do</span></h1>
          <hr class="space space-xs">
        </div>
        <div class="col col-sm-6 offset-sm-3">
          <p class="text-center">
            We enjoy getting out of our comfort zones, but we also try to focus on what we're best at: creating innovative and unique digital products.
          </p>
          <hr class="space">
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-6">
          <h1 class="title text-center h1-lg py-4">
            <span class="text-primary">Branding</span> &amp;<br/> Visual Identity
          </h1>
          <p class="no-margin text-center">
            Concept and Ideation<br/>
            Brand Planning &amp; Architecture<br/>
            Principles and values<br/>
            Tone of voice<br/>
            Positioning<br/>
          </p>
          <hr class="space space-sm">
        </div>

        <div class="col-12 col-sm-6">
          <h1 class="title text-center h1-lg py-4">
            <span class="text-primary">Creative</span> &amp;<br/> Design
          </h1>
          <p class="no-margin text-center">
            Graphic Design<br/>
            Print &amp; Collateral<br/>
            App &amp; Web Design<br/>
            UX &amp; UI<br/>
            Illustration &amp; Animation<br/>
            <br/>
          </p>
          <hr class="space space-sm">
        </div>

        <div class="col-12 col-sm-6">
          <h1 class="title text-center h1-lg py-4">
            <span class="text-primary">Digital</span> products
          </h1>
          <p class="no-margin text-center">
            Mobile &amp; Web Apps<br/>
            Blockchain and Digital Collectibles<br/>
            Compliance<br/>
            Metrics &amp; Optimisation<br/>
            Go To Market &amp; Market Fit
          </p>
          <hr class="space space-sm">
        </div>

        <div class="col-12 col-sm-6">
          <h1 class="title text-center h1-lg py-4">
            <span class="text-primary">Product</span> direction
          </h1>
          <p class="no-margin text-center">
            Innovation Strategy<br/>
            Digital Transformation<br/>
            Pivoting &amp; Rebuild<br/>
            Roadmapping<br/>
            Metrics &amp; Optimisation<br/>
          </p>
          <hr class="space space-sm">
        </div>
      </div>
      <hr />
      <hr class="space">
      <div class="row">
        <div class="col col-md-8 offset-md-2 text-center">
          <p>Also...</p>
          <h1 class="h1-lg py-4">We practice what we preach</h1>
          <p>
            This is not just a website. We've built a bespoke platform to ensure
            working with us is as smooth and transparent as possible.
          </p>
          <p>
            You get 24/7 access to the latest status of your project any time you want, a test version
            you can try (or demo to anyone you want), all the source code and assets.
          </p>
          <p>
            We are also human, and you can talk to us anytime you need.
          </p>
          <hr class="space space-xs">
          <router-link class="btn btn-primary" :to="{ name: 'request-proposal' }">Get in touch</router-link>
          <router-link class="btn btn-outline-primary" :to="{ name: 'about' }">About us</router-link>
        </div>
      </div>
      <hr class="space">
    </div>
    <hr class="divider">
  </div>
</template>

<script>
export default {
  name: 'services',
  data () {
    return {
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
}
</script>
